import styled from 'styled-components';

export const OverviewDiseasesColumnButtons = styled.div`
  align-self: end;
  display: flex;
  grid-column-gap: 0.5rem;
`;
